import React, { useEffect, useState, useContext } from 'react';
import './Login.scss';
import { useNavigate } from 'react-router-dom';
// import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import loginBack from '../../assets/login.png'
import askweiLogo from '../../assets/logo.png'
import showLogo from '../../assets/show.png'
import notShowLogo from '../../assets/notShow.png'
import axios from 'axios';
// import { connect } from 'react-redux';
// import { Login} from '../../redux/actions';
import { REACT_APP_WORKING_URL } from '../../Constants'
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import StoredUserContext from '../../context/StoredUserContext';



function LoginPageCN() {
  const navigate = useNavigate();
  const [contextUser, setContextUser] = useContext(StoredUserContext);
  const { referer } = useParams();
  const [show, setShow] = useState(false);

  const [loginForm, setLoginForm] = useState({
    email: localStorage.getItem('rememberedFormData') ? JSON.parse(localStorage.getItem('rememberedFormData')).email : "",
    password: localStorage.getItem('rememberedFormData') ? JSON.parse(localStorage.getItem('rememberedFormData')).password : ""
  })


  const [rememberedForm, setRememberedForm] = useState(localStorage.getItem('rememberedFormData') ? true : false)

  const apiUrl = REACT_APP_WORKING_URL

  useEffect(() => {
    const func = async () => {
      if (referer) {
        localStorage.removeItem('user');
        localStorage.setItem('referer', referer);
        // const {data} = await axios.get(`${apiUrl}users/ref/${referer}`);
      }
    }
    func();
  }, [])




  useEffect(() => {

    // const script = document.createElement("script");

    // script.firebase = "https://www.gstatic.com/firebasejs/8.0/firebase.js";
    // script.async = true;
    // script.onload = () => {
    //   const config = {
    //     apiKey: "AIzaSyDPv3uvZR5_AeXzg4c0kOGqlelIwlR4GCo",
    //     authDomain: "weieducation-auth.firebaseapp.com",
    //   };
    //   firebase.initializeApp(config);
    //   console.log('here');


    // };

    // document.body.appendChild(script);
    // return () => {
    //   document.body.removeChild(script);
    // };


    // google.accounts.id.initialize({
    //   client_id: "819859352837-b52idq2vo842v2gs3r04av6ik613edbd.apps.googleusercontent.com",
    //   callback: (data)=>{
    //     handleGoogleLoginSuccess(data);
    //   }
    // });
    // google.accounts.id.renderButton(
    //   document.getElementById("buttonDiv"),
    //   { theme: "outline", size: "large" }  // customization attributes
    // );
    // // google.accounts.id.prompt(); // also display the One Tap dialog

  }, [])

  const handlePasswordChange = (e) => {
    setLoginForm({
      email: loginForm.email,
      password: e.target.value
    })
    if (rememberedForm) {
      localStorage.setItem('rememberedFormData', JSON.stringify({
        ...JSON.parse(localStorage.getItem('rememberedFormData')),
        password: e.target.value
      }))
    }
  }

  const handleEmailChange = (e) => {
    setLoginForm({
      email: e.target.value,
      password: loginForm.password
    })
    if (rememberedForm) {
      localStorage.setItem('rememberedFormData', JSON.stringify({
        ...JSON.parse(localStorage.getItem('rememberedFormData')),
        email: e.target.value
      }))
    }
  }

  const handleRememeberForm = (e) => {
    setRememberedForm(!rememberedForm);
    if (localStorage.getItem('rememberedFormData')) {
      localStorage.removeItem('rememberedFormData')
    }
    else {
      localStorage.setItem('rememberedFormData', JSON.stringify(loginForm))
    }
  }


  const handleLogin = (e) => {
    e.preventDefault()
    if (loginForm.email.indexOf('@') === -1) {
      alert("Username login is not open, please login by email!")
    }
    else {
      const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!regex.test(loginForm.email) || loginForm.email === '') {
        alert('Please input correct email address!')
      }
      else {
        axios.post(`${apiUrl}users/loginByForm`, { email: loginForm.email.toLowerCase(), password: loginForm.password }, { 'Content-Type': 'application/json' })
          .then(res => {
            // 处理响应数据
            localStorage.setItem('user', JSON.stringify(res.data))
            setContextUser(res.data);
            navigate('/pre-home')
            // Login(res.data)
          })
          .catch((error) => {
            // 处理请求错误
            if (error.response && error.response.status === 404) {
              alert('404: Email account is not corresponding to the password.');
            }
            else if (error.response && error.response.status === 500) {
              alert('500: Server internal problem.')
            }
            else alert(error)
          });
      }
    }
  }

  //   const handleGoogleLoginSuccess = (res) => {
  //     const googleUser = jwt_decode(res.credential)
  //     const user = {
  //       user_name:googleUser.name,
  //       password_hash:'',
  //       email:googleUser.email,
  //       nick_name:googleUser.name,
  //       avatar_url:googleUser.picture,
  //       phone_number:'',
  //       bio:'',
  //       is_verified:1,
  //       security_level:1
  //     }
  //     axios.post(`${apiUrl}users/loginByGoogle`, {...user}, {'Content-Type': 'application/json'})
  //     .then((res) => {
  //       // 处理响应数据
  //       localStorage.setItem('user', JSON.stringify(res.data))
  //       setContextUser(res.data);
  //       navigate('/pre-home')
  //     })
  //     .catch((error) => {
  //       // 处理请求错误
  //       alert('Wrong request:', error);
  //     });
  //   };

  //   const handleGoogleLoginFailure = (error) => {
  //     alert('Google internal server error:', error);
  //   };

  //   const handleTestLoginClick = ()=>{
  //     // var email = "fei@123.com";
  //     // var password = "123456";
  //     // console.log('here');
  //     // firebase.auth().onAuthStateChanged(function(user) {
  //     //   if (user) {
  //     //     alert("Welcome, " + user.email);
  //     //  } else {
  //     //   alert("No user signed in.");
  //     //   }
  //     // });
  //     // console.log('here2');

  //     // firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
  //     //   alert(error.message);
  //     // });

  //     // google.accounts.id.initialize({
  //     //   client_id: "819859352837-b52idq2vo842v2gs3r04av6ik613edbd.apps.googleusercontent.com",
  //     //   callback: (data)=>{console.log('data is', data)}
  //     // });
  //     // google.accounts.id.renderButton(
  //     //   document.getElementById("buttonDiv"),
  //     //   { theme: "outline", size: "large" }  // customization attributes
  //     // );
  //     // google.accounts.id.prompt(); // also display the One Tap dialog
  //   }

  return (
    <>

      <img src={loginBack} style={{ width: '100vw', height: '100vh' }} />
      <div style={{ position: 'absolute', right: '10px', top: '10px' }}>
        <a href='https://www.weieducation.ca/' style={{ fontWeight: 'bold' }}>ABOUT WEI-EDU</a>
      </div>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <form className='login' onSubmit={handleLogin} style={{ background: 'rgba(255, 255, 255, 0.8)', height: 'fit-content', padding: '50px 100px', borderRadius: '30px', width: '500px' }}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img src={askweiLogo} style={{ height: '88px', width: 'auto', marginBottom: '50px' }} />
          </div>
          <h1 style={{ fontSize: '32px', lineHeight: '37.5px', fontWeight: 700, marginBottom: '12px', }}>Log In</h1>
          <div style={{ borderBottom: '2px dashed #4CE39B', marginBottom: '50px' }} />
          <div className='input-container'>
            <div className='tag'>Enter your email address</div>
            <div>
              <input type="text" onChange={handleEmailChange} value={loginForm.email} />
            </div>
          </div>
          <div style={{ height: '24px' }} />
          <div className='input-container'>
            <div className='tag'>Password</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
              <input type={show ? "text" : "password"} onChange={handlePasswordChange} value={loginForm.password} />
              <img src={show ? notShowLogo : showLogo} style={{ width: '21px', height: '15px', color: 'black' }} onClick={() => { setShow(!show) }} />
            </div>
          </div>
          <div style={{ height: '12px' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className="d-flex">
              <input type="checkbox" style={{ marginRight: "8px", width: '20px', border: '1px solid red' }} onChange={handleRememeberForm} checked={rememberedForm} />
              <div className=''>
                Remember Email and Password
              </div>
            </div>
            <a href="/reset-password" style={{ color: 'red', textDecoration: 'none' }}>Forgot password?</a>
          </div>
          <div style={{ height: '50px' }} />
          <button type="submit" style={{ border: 'none', color: 'white', backgroundColor: '#4CE39B', width: '100%', height: '38px', borderRadius: '4px', fontWeight: 'bold' }}>Login</button>
          <div style={{ height: '24px' }} />
          <div id="buttonDiv" ></div>
          <div style={{ height: '50px' }} />
          <div className='d-flex justify-content-center'>
            <span style={{ fontSize: '0.75rem', fontWeight: 500 }}>Not a member yet?</span>&nbsp;&nbsp;<a style={{ textDecoration: "none", fontSize: '0.75rem', fontWeight: 500, color: '#4CE39B' }} href='/register'>Sign up!</a>
          </div>
        </form>
      </div>
    </>

  );
}
// const mapStateToProps = (state) => ({
//   loginUser: state.user,
// });

// const mapDispatchToProps = {
//   Login,
// };
// export default connect(mapStateToProps, mapDispatchToProps)(LoginPageCN);

// function Test (){
//   return (<div>
//     haha
//   </div>);
// }
export default (LoginPageCN);
// export default Test;